import {
    Breadcrumbs,
    BreadcrumbsLink,
    Button,
    Container,
    Loader,
    Stack,
    Typography,
} from "@octopus-energy/coral/atoms"
import { type ISbStoriesParams, type ISbStoryData } from "@storyblok/react"
import { type StoryblokBreadCrumb } from "../../hooks/useStoryblokBreadcrumb"
import { getStoryHref } from "../../utils/getStoryHref"
import { StoryblokCategories } from "../Categories"

type StoryblokFAQCategoryProps = {
    crumbs: StoryblokBreadCrumb[]
    title: string
    stories: ISbStoryData[]
    options: ISbStoriesParams
    isLoading: boolean
}

export function StoryblokFAQCategory({
    crumbs,
    options,
    stories,
    title,
    isLoading,
}: StoryblokFAQCategoryProps) {
    return (
        <Stack
            component="article"
            flexDirection="column"
            gap="md"
        >
            <nav>
                <Breadcrumbs>
                    {crumbs.map((crumb, index) => (
                        <BreadcrumbsLink
                            key={crumb.href}
                            href={crumb.href}
                            current={index === crumbs.length - 1}
                        >
                            {crumb.title}
                        </BreadcrumbsLink>
                    ))}
                </Breadcrumbs>
            </nav>
            {!isLoading && <StoryblokCategories options={options} />}
            <Container component="header">
                <Typography
                    textStyle="h1"
                    textAlign="center"
                >
                    {title}
                </Typography>
            </Container>
            {isLoading ? (
                <Container
                    marginX="auto"
                    marginY="xxxl"
                >
                    <Loader />
                </Container>
            ) : (
                <Stack flexDirection="column">
                    {stories.map((s) => (
                        <Button
                            key={s.name}
                            href={getStoryHref(s)}
                            color="secondary500"
                            variant="outlined"
                            fullWidth
                        >
                            {s.content.title}
                        </Button>
                    ))}
                </Stack>
            )}
        </Stack>
    )
}
